import { render, staticRenderFns } from "./picshowtable.vue?vue&type=template&id=5485f813&scoped=true&"
import script from "./picshowtable.vue?vue&type=script&lang=js&"
export * from "./picshowtable.vue?vue&type=script&lang=js&"
import style0 from "./picshowtable.vue?vue&type=style&index=0&id=5485f813&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485f813",
  null
  
)

export default component.exports